import React, { useContext } from 'react';
import { Button, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { ConfirmationDialog } from '@mummssoftware/common-ui';
import { Context } from '../../context';
import defaults from '../../translations/en.json';

const CarePlanErrorButtonsDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`;

export const CarePlanErrorDialog = () => {
  const { carePlanErrorPatient, clearCarePlanError } = useContext(Context);

  if (!carePlanErrorPatient) {
    return null;
  }

  return (
    <ConfirmationDialog
      open
      title={defaults.carePlanErrorTitle}
      fullWidth
      maxWidth="sm"
      disableBackdropClick
      handleClick={clearCarePlanError}
      noIcon
    >
      <Typography>
        {defaults.carePlanErrorMessage.replace(
          '{patientNumber}',
          carePlanErrorPatient,
        )}
      </Typography>
      <CarePlanErrorButtonsDiv>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={clearCarePlanError}
        >
          {defaults.carePlanErrorOk}
        </Button>
      </CarePlanErrorButtonsDiv>
    </ConfirmationDialog>
  );
};

export default CarePlanErrorDialog;
